const tags = document.querySelectorAll('.tag--element');

function initTags() {
  tags.forEach((tag) => tag.addEventListener('click', function addEventclick() {
      const tagsContainer = this.closest('.tags--descriptions');
      const tagIndex = this.dataset.index;
      const containerDescription = tagsContainer.querySelector(`#${tagIndex}`);
      const textDescription = tagsContainer.querySelectorAll('.text--description')
      tags.forEach((tag) => {
        if (!tag.classList.contains('tag-hidden')) {
          tag.classList.add('tag-hidden');
        }
      });
      textDescription.forEach((description) => {
        if (!description.classList.contains('tag-hidden')) {
          description.classList.add('tag-hidden');
        }
      });
      this.classList.remove('tag-hidden');
      containerDescription.classList.remove('tag-hidden');
    }),
  );
}

if (tags) initTags();
